export default "__VITE_ASSET__oo2zmLrY__"